import React from 'react'
import { Row } from './styles'

const Component = ({children, ...rest}:any) => {
  return <Row {...rest}>{children}</Row>
}

export default Component